import { useMutation, useQueryClient } from '@tanstack/react-query';

import { onboardUser } from '~/services/AgentHub/AgentService';

export function useOnboardUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (userId: string) => {
      return await onboardUser(userId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['list-eoi'] });
    },
  });
}
